module.exports = require('./helpers/bundle-url').getBundleURL('fqZHd') + "logo.c51670a8.svg";